class SuperVideo extends HTMLElement {
    constructor(){
        super();
        this.video = this.querySelector('video');
        this.playBtn = this.querySelector('.action-btns .play-icon');
        this.pauseBtn = this.querySelector('.action-btns .pause-icon');
        this.muteBtn = this.querySelector('.bottom-area button:nth-child(1)');
        this.zoomBtn = this.querySelector('.bottom-area button:nth-child(2)');
        this.progress = this.querySelector('.progress');
        this.timer = this.querySelector('.timer');

        this.playBtn?.addEventListener('click', this.playVideo.bind(this));
        this.pauseBtn?.addEventListener('click', this.pauseVideo.bind(this));
        this.muteBtn?.addEventListener('click', this.toggleMute.bind(this));
        this.zoomBtn?.addEventListener('click', this.toggleFullScreen.bind(this));

        document.addEventListener('fullscreenchange', this.onFullScreenChange.bind(this));

        this.video?.addEventListener('play', this.onPlay.bind(this));
        this.video?.addEventListener('pause', this.onPause.bind(this));
        this.video?.addEventListener('ended', this.onEnd.bind(this));
        this.video?.addEventListener('timeupdate', this.updateProgress.bind(this));

        this.progress?.parentElement.addEventListener('click', this.seekVideo.bind(this));
    }

    playVideo = () => {
        this.video?.play();
    }

    pauseVideo = () => {
        this.video?.pause();
    }

    onPlay = () => {
        this.classList.add('play');
    }

    onPause = () => {
        this.classList.remove('play');
    }

    onEnd = () => {
        this.classList.remove('play');
    }

    // Mute / Unmute
    toggleMute = () => {
        if (!this.video) return;
        this.video.muted = !this.video.muted;
    }

    // Fullscreen
    toggleFullScreen = () => {
        if (!document.fullscreenElement) {
            this.requestFullscreen?.();
            this.classList.add('full-screen');
        } else {
            document.exitFullscreen?.();
            this.classList.remove('full-screen');
        }
    }
    
    onFullScreenChange = () => {
    if (!document.fullscreenElement) {
        this.classList.remove('full-screen');
    }
}

    // Progress update
    updateProgress = () => {
        if (!this.video || !this.progress) return;
        const percent = (this.video.currentTime / this.video.duration) * 100;
        this.progress.style.setProperty('--width', `${percent}%`);
        this.updateTime(this.video.currentTime);
    }

    // Timer text
    updateTime = (seconds) => {
        if (!this.timer) return;
        const m = Math.floor(seconds / 60).toString().padStart(2, '0');
        const s = Math.floor(seconds % 60).toString().padStart(2, '0');
        this.timer.textContent = `${m} : ${s}`;
    }

    // Seek on click
    seekVideo = (e) => {
        if (!this.video) return;

        const container = e.currentTarget;
        const rect = container.getBoundingClientRect();
        const offsetX = e.clientX - rect.left;
        const percent = offsetX / rect.width;

        this.video.currentTime = percent * this.video.duration;
    }
}

customElements.define('super-video', SuperVideo);

class SuperSwiper extends HTMLElement {
    constructor(){
        super();
        this.swiperEl = this.querySelector('.swiper');
        this.config = JSON.parse(this.querySelector('script').textContent);
        this.swiper = new Swiper(this.swiperEl, this.config);
    }
}

customElements.define('super-swiper', SuperSwiper);

class ProSlider extends HTMLElement {
    constructor(){
        super();
        this.swiperEl = this.querySelector('.swiper');
        this.config = JSON.parse(this.querySelector('script').textContent);
        this.swiper = new Swiper(this.swiperEl, this.config);
    }
}

customElements.define('pro-slider', ProSlider);


class FrqBought extends HTMLElement {
    constructor(){
        super();
        this.swiperEl = this.querySelector('.swiper');
        this.config = JSON.parse(this.querySelector('script').textContent);
        this.swiper = new Swiper(this.swiperEl, this.config);
    }
}

customElements.define('frq-bought', FrqBought);

